import { IRace } from 'src/app/models/race.interface';

export interface IEventState {
    event: IRace[];
}

export const initialEventState: IEventState = {
    event: null
};
